"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariantRegion = void 0;
const getOrderLineRegionId_1 = require("./getOrderLineRegionId");
const getVariantRegion = (variant) => {
    if (!variant)
        return null;
    if (!variant.order_lines || variant.order_lines.length === 0)
        return null;
    return (0, getOrderLineRegionId_1.getOrderLineRegionId)(variant.order_lines[0]);
};
exports.getVariantRegion = getVariantRegion;
